<template>
  <v-container>
    <v-btn elevation="2" fab absolute small @click="$router.go(-1)" v-show="!$vuetify.breakpoint.smAndDown"><v-icon
        color="primary">mdi-arrow-left-bold</v-icon></v-btn>

    <v-row dense>
      <v-col class="text-h3" align="center">
        <div class="d-flex justify-center align-center">
          {{ category.name }}
          <v-icon large v-if="category.private">mdi-file-hidden</v-icon>
          <InlineNotificationControl v-if="isAuthenticated && category.id" :categoryId="category.id" class="ml-2" />
        </div>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col class="text-h5" align="center">
        {{ category.sub_name }}
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="6" class="text-body">
        <v-expansion-panels v-model="description_show">
          <v-expansion-panel @click="technical_info_show = undefined">
            <v-expansion-panel-header class="text-h6">
              O čo nám ide?
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="$vuetify.breakpoint.smAndDown">
              <html-replace v-if="category.description" :html="category.description"></html-replace>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>

      <v-col cols="12" md="6" class="text-body">
        <v-expansion-panels v-model="technical_info_show">
          <v-expansion-panel @click="description_show = undefined">
            <v-expansion-panel-header class="text-h6">
              Technické informácie
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="$vuetify.breakpoint.smAndDown">
              <html-replace v-if="category.technical_info" :html="category.technical_info"></html-replace>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <div v-show="!$vuetify.breakpoint.smAndDown">
      <v-row no-gutters v-show="description_show == 0">
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <html-replace v-if="category.description" :html="category.description"></html-replace>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row no-gutters v-show="technical_info_show == 0">
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <html-replace v-if="category.technical_info" :html="category.technical_info"></html-replace>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <v-row justify="space-between" align="center" no-gutters>
      <v-col cols="12" md="6" class="text-left" align-self="start">
        <v-text-field v-model="search" label="Vyhľadaj" clearable></v-text-field>
      </v-col>

      <v-col cols="12" sm="6" md="6" lg="4" align="right" class="d-flex align-center justify-end">
        <v-btn-toggle v-model="view_type" mandatory borderless dense class="mr-4">
          <v-btn value="grid" icon>
            <v-icon>mdi-view-grid-outline</v-icon>
          </v-btn>
          <v-btn value="list" icon>
            <v-icon>mdi-view-list</v-icon>
          </v-btn>
        </v-btn-toggle>

        <v-btn v-if="filter_favorite" text color="amber amber-darken-4" @click="filter_favorite = false">
          Iba obľúbené &nbsp;<v-icon>mdi-star</v-icon>
        </v-btn>

        <v-btn v-else text color="amber amber-darken-4" @click="filter_favorite = true">
          Iba obľúbené &nbsp;<v-icon>mdi-star-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row class="mt-4">
      <v-col cols="12">
        <v-row align="stretch" v-if="view_type === 'grid'">
          <v-col v-for="poll in polls" v-bind:key="poll.id" cols="12" md="6" lg="4" class="d-flex">
            <v-card hover class="flex-grow-1 d-flex flex-column rounded-lg" outlined
              :to="poll.url ? poll.url : '/poll_category/' + category.id + '/poll/' + poll.id + '/'">
              <v-card-title
                class="d-flex justify-space-between align-start text-h6 primary--text word-break-normal pt-4">
                <span style="word-break: break-word; line-height: 1.3;">{{ poll.name }}</span>
                <div class="d-flex align-center ml-2">
                  <v-icon v-if="poll.private" small>mdi-file-hidden</v-icon>
                </div>
              </v-card-title>

              <v-card-subtitle class="pb-2 mt-1">
                <v-chip v-if="poll.not_voted_questions_count" color="red lighten-5" text-color="red darken-2" small
                  label class="font-weight-bold">
                  Nehlasované: {{ poll.not_voted_questions_count }}
                </v-chip>
                <v-chip v-else color="green lighten-5" text-color="green darken-2" small label class="font-weight-bold">
                  <v-icon left small>mdi-check</v-icon>
                  Všetko odhlasované
                </v-chip>
              </v-card-subtitle>

              <v-card-text class="flex-grow-1">
                <div v-if="poll.authors && poll.authors.length > 0" class="mt-2">
                  <div class="text-caption grey--text mb-1">Authori:</div>
                  <div class="d-flex flex-wrap align-center">
                    <div v-for="(author, index) in poll.authors.slice(0, 3)" :key="index"
                      class="d-flex align-center mr-3 mb-2">
                      <v-avatar size="28" class="mr-2 white--text" :color="author.photo ? '' : 'grey lighten-1'">
                        <v-img :src="author.photo" v-if="author.photo"></v-img>
                        <span v-else class="text-caption font-weight-bold">{{ author.first_name.charAt(0) }}{{
                          author.last_name.charAt(0) }}</span>
                      </v-avatar>
                      <span class="text-body-2 font-weight-medium text-truncate" style="max-width: 120px;">
                        {{ author.first_name }} {{ author.last_name }}
                      </span>
                    </div>
                    <v-chip v-if="poll.authors.length > 3" x-small class="mb-2">
                      +{{ poll.authors.length - 3 }} ďalších
                    </v-chip>
                  </div>
                </div>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions class="justify-space-between pa-3 grey lighten-5">
                <div @click.prevent class="d-flex align-center">
                  <InlineNotificationControl v-if="isAuthenticated" :pollId="poll.id" />
                  <span class="ml-2 text-caption grey--text d-none d-sm-inline">Upozornenia</span>
                </div>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" @click.prevent="poll.user_favorite ? removeFavorite(poll.id) : addFavorite(poll.id)">
                      <v-icon :color="poll.user_favorite ? 'amber darken-4' : 'grey lighten-1'">
                        {{ poll.user_favorite ? 'mdi-star' : 'mdi-star-outline' }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ poll.user_favorite ? 'Zrušiť obľúbené' : 'Pridať obľúbené' }}</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-list v-else flat class="transparent">
          <v-list-item-group color="primary">
            <v-card v-for="poll in polls" :key="poll.id" class="mb-3 rounded-lg flex-grow-1 d-flex flex-column" outlined
              hover :to="poll.url ? poll.url : '/poll_category/' + category.id + '/poll/' + poll.id + '/'">
              <div class="d-flex align-center pa-2 w-100">
                <div class="flex-grow-1 px-2 overflow-hidden">
                  <div class="d-flex align-center flex-wrap">
                    <span class="text-subtitle-1 font-weight-bold primary--text mr-2 text-truncate"
                      style="max-width: 70%;">{{ poll.name }}</span>
                    <v-icon v-if="poll.private" small class="mr-2">mdi-file-hidden</v-icon>

                    <v-chip v-if="poll.not_voted_questions_count" color="red lighten-5" text-color="red darken-2"
                      x-small label class="font-weight-bold mr-2">
                      Nehlasované: {{ poll.not_voted_questions_count }}
                    </v-chip>
                    <v-chip v-else color="green lighten-5" text-color="green darken-2" x-small label
                      class="font-weight-bold mr-2">
                      <v-icon left x-small>mdi-check</v-icon>
                      Všetko odhlasované
                    </v-chip>
                  </div>

                  <div class="d-flex align-center mt-1">
                    <div v-if="poll.authors && poll.authors.length > 0" class="d-flex align-center flex-wrap">
                      <div v-for="(author, index) in poll.authors.slice(0, 3)" :key="index"
                        class="d-flex align-center mr-3">
                        <v-avatar size="20" class="mr-1 white--text" :color="author.photo ? '' : 'grey lighten-1'">
                          <v-img :src="author.photo" v-if="author.photo"></v-img>
                          <span v-else class="text-caption font-weight-bold" style="font-size: 8px !important;">{{
                            author.first_name.charAt(0) }}{{
                              author.last_name.charAt(0) }}</span>
                        </v-avatar>
                        <span class="text-caption grey--text text--darken-1">{{ author.first_name }} {{ author.last_name
                        }}</span>
                      </div>
                      <v-chip v-if="poll.authors.length > 3" x-small>
                        +{{ poll.authors.length - 3 }}
                      </v-chip>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-center px-2" @click.stop.prevent>
                  <InlineNotificationControl v-if="isAuthenticated" :pollId="poll.id" />
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small
                        v-bind="attrs"
                        v-on="on"
                        @click.stop.prevent="poll.user_favorite ? removeFavorite(poll.id) : addFavorite(poll.id)"
                        class="ml-1">
                        <v-icon :color="poll.user_favorite ? 'amber darken-4' : 'grey lighten-1'">
                          {{ poll.user_favorite ? 'mdi-star' : 'mdi-star-outline' }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ poll.user_favorite ? 'Zrušiť obľúbené' : 'Pridať obľúbené' }}</span>
                  </v-tooltip>
                </div>
              </div>
            </v-card>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

import { APIService } from "@/http/APIService.js";

import HtmlReplace from '../HtmlReplace.vue';
import InlineNotificationControl from "@/components/notifications/InlineNotificationControl.vue";

const apiService = new APIService();


export default {
  name: 'Poll',
  inheritAttrs: true,

  components: {
    HtmlReplace,
    InlineNotificationControl
  },

  props: {
    categoryID: { type: Number, required: true },
  },

  data() {
    return {
      category: {
        polls: []
      },
      description_show: undefined,
      technical_info_show: undefined,

      filter_favorite: false,
      search: "",
      view_type: 'grid'
    }
  },

  computed: {
    ...mapGetters("auth", [
      "isAuthenticated",
      "username",
      "isVerified",
      "isVerifiedBank",
      "isVerifiedSmsEmail",
      "isStaff",
      "getMemberStatus",
      "firstName",
      "lastName",
      "gender",
      "user_id"
    ]),

    ...mapGetters("settings", ["getSettings"]),

    polls() {
      let tmp = [...this.category.polls];
      if (this.filter_favorite)
        tmp = tmp.filter((poll) => poll.user_favorite);

      if (this.search)
        tmp = tmp.filter((poll) => poll.name.toLowerCase().includes(this.search.toLowerCase()));

      return tmp;
    }
  },


  events: {},

  watch: {
    view_type(val) {
      localStorage.setItem("poll_category_view_type", val);
    }
  },

  mounted: function () {
    if (localStorage.getItem("poll_category_view_type")) {
      this.view_type = localStorage.getItem("poll_category_view_type");
    }
    this.getCategory();
  },

  methods: {
    removeFavorite(id) {
      apiService.generalPollRemoveFavorite(id).then(() => {
        this.getCategory();
      });
    },

    addFavorite(id) {
      apiService.generalPollAddFavorite(id).then(() => {
        this.getCategory();
      });
    },

    getCategory() {
      apiService.getGeneralPollCategory(this.categoryID).then(response => {
        this.category = response;
      });
    }
  },
};
</script>
